import { categories } from "@/mocks/categories";

const featured = categories.slice(0, 3);

export default function GridSection() {
  return (
    <section className="relative w-full py-16 md:py-24 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14">
        <div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight">
            Navegue por<br />
            <span className="italic font-normal">Categoria</span>
          </h2>
        </div>
        <p className="text-sm text-foreground-500 max-w-xs mt-4 md:mt-0 leading-relaxed">
          Explore nossas categorias em destaque com os produtos mais populares da <strong>planilha CSSBuy</strong>.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {/* Left - Featured Large Card */}
        <div className="md:col-span-1 relative rounded-2xl overflow-hidden bg-foreground-900 group cursor-pointer h-[420px] md:h-[500px]">
          <img
            src={featured[0].image}
            alt={featured[0].namePt}
            title={featured[0].namePt + " CSSBuy"}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
            <h3 className="text-background-50 text-xl md:text-2xl font-heading font-bold mb-2 whitespace-nowrap">
              {featured[0].namePt}
            </h3>
            <p className="text-background-50/70 text-sm mb-4">{featured[0].description}</p>
            <a
              href={featured[0].url}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 bg-background-50 text-foreground-950 text-xs font-semibold px-5 py-2.5 rounded-full cursor-pointer transition-all hover:bg-background-100 whitespace-nowrap"
            >
              Ver Produtos
              <i className="ri-arrow-right-up-line text-sm"></i>
            </a>
          </div>
        </div>

        {/* Middle & Right Cards */}
        {featured.slice(1).map((cat) => (
          <div
            key={cat.id}
            className="md:col-span-1 relative rounded-2xl overflow-hidden bg-background-100 group cursor-pointer h-[420px] md:h-[500px] border border-background-200/50"
          >
            <div className="absolute top-4 left-4 z-10 flex items-center gap-1.5 bg-accent-100 text-accent-800 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              Popular
            </div>

            <div className="h-[55%] overflow-hidden">
              <img
                src={cat.image}
                alt={cat.namePt}
                title={cat.namePt + " CSSBuy"}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>

            <div className="p-5 md:p-6 flex flex-col justify-between h-[45%]">
              <div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-1 whitespace-nowrap">
                  {cat.namePt}
                </h3>
                <p className="text-xs text-foreground-500">{cat.description}</p>
              </div>
              <a
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 bg-foreground-950 text-background-50 text-xs font-semibold px-5 py-2.5 rounded-full cursor-pointer transition-all hover:bg-foreground-800 whitespace-nowrap w-fit"
              >
                Ver Produtos
                <i className="ri-arrow-right-up-line text-sm"></i>
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}